import $ from 'jquery';
import { modifyState, getState } from '~src/state';
import { RULER_SIZE } from './constants';
import {
  createRulers,
  drawRulerMarks,
  updateRulerContexts,
  resizeRulerCanvases,
  onAfterRender,
} from './rulerRenderer';
import {
  setupRulerEventListeners,
  handleObjectMoving,
  handleObjectModified,
} from './eventHandlers';
import {
  guidelines,
  clearGuidelines as clearGuidelinesInternal,
  updateGuidelinesVisibility,
  loadExistingGuidelines,
} from './guidelineManagement';
import { registerGuidelineClass } from './Guideline';
import { getSnapManager, updateSnappingOptions } from '../snapping';

// Module state
let rulerEnabled = false;
let rulerUnit = 'cm'; // 'px', 'mm', or 'cm' - default to cm for print users

// Export getters for module state
const getRulerEnabled = () => rulerEnabled;
const getRulerUnit = () => rulerUnit;

export const initRuler = () => {
  const canvas = window.canvas;
  if (!canvas) return;

  // Enable ruler snapping in the snap manager if it exists
  const snapManager = getSnapManager();
  if (snapManager) {
    updateSnappingOptions({ enableRulerSnapping: true });
  }

  // Register Guideline class
  registerGuidelineClass(getState, guidelines);

  createRulers();
  setupRulerEventListeners(getRulerEnabled, getRulerUnit);
  modifyState('rulerEnabled', false);
};

export const toggleRuler = () => {
  rulerEnabled = !rulerEnabled;
  modifyState('rulerEnabled', rulerEnabled);

  if (rulerEnabled) {
    // Make sure rulers exist
    if (
      $('#horizontal-ruler').length === 0 ||
      $('#vertical-ruler').length === 0
    ) {
      createRulers();
    }

    $('#horizontal-ruler, #vertical-ruler').show();
    $('#main-canvas-container').css({
      marginTop: RULER_SIZE + 'px',
      marginLeft: RULER_SIZE + 'px',
    });

    // Update ruler canvases
    updateRulerContexts();
    drawRulerMarks(rulerUnit);

    // Load existing guidelines
    loadExistingGuidelines();
  } else {
    $('#horizontal-ruler, #vertical-ruler').hide();
    $('#main-canvas-container').css({
      marginTop: '0',
      marginLeft: '0',
    });
    // Hide all guidelines instead of removing them
    updateGuidelinesVisibility(false);
  }

  // Update button state
  if (rulerEnabled) {
    $('#editor-menu-ruler').addClass('btn-header-selected');
  } else {
    $('#editor-menu-ruler').removeClass('btn-header-selected');
  }
};

export const clearGuidelines = () => {
  clearGuidelinesInternal();
};

export const setRulerUnit = (unit) => {
  if (['px', 'mm', 'cm'].includes(unit)) {
    rulerUnit = unit;
    modifyState('rulerUnit', unit);

    // Redraw rulers with new units
    if (rulerEnabled) {
      drawRulerMarks(rulerUnit);
    }
  }
};

export const resizeRulers = (width, height) => {
  resizeRulerCanvases(width, height);

  if (rulerEnabled) {
    drawRulerMarks(rulerUnit);
  }
};

export { getRulerUnit };

// Export functions to be called from main canvas events
export const handleRulerAfterRender = () => {
  onAfterRender(rulerEnabled);
};

export const handleRulerObjectMoving = (e) => {
  handleObjectMoving(e, rulerUnit);
};

export const handleRulerObjectModified = (e) => {
  handleObjectModified(e);
};
